import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Text, useSettings, Icon, showDeleteDialog } from 'app/main/components';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';
import { AuthorizerContext } from 'app/providers/acl/AclProvider';

export default function PhonesListItem(props: ItemLayoutProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const authorizer = React.useContext(AuthorizerContext);

	const editPhone = () => {
		dispatch(
			showFastAddDialog({
				module: 'phones',
				isUpdate: true,
				model: props.model,
				maxDialogWidth: 'sm',
				updateRefresh: props.buttonProps.updateRefresh,
				additionalProps: { disableIdentityAssociation: true }
			})
		);
	};

	const deletePhone = () =>
		dispatch(
			showDeleteDialog({
				module: 'phones',
				id: props.model.phon_uid,
				title: props.model.phon_title,
				updateRefresh: props.buttonProps.updateRefresh
			})
		);

	const secondaryAction = (
		<>
			{authorizer.can('update', 'phone') && (
				<IconButton size="small" onClick={editPhone}>
					<Icon icon="pencil" />
				</IconButton>
			)}
			{authorizer.can('delete', 'phone') && (
				<IconButton size="small" onClick={deletePhone} edge="end">
					<Icon icon="delete" />
				</IconButton>
			)}
		</>
	);

	return (
		<GridListItem secondaryAction={secondaryAction}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={12} className="inline-flex items-center">
					{/* WARNING */}
					{props.model.phon_warning_desc && (
						<Tooltip title={props.model.phon_warning_desc} arrow>
							<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
						</Tooltip>
					)}
					{/* BLOCKED */}
					{props.model.phon_blocked_desc && (
						<Tooltip title={props.model.phon_blocked_desc} arrow>
							<Icon className="mr-2" icon="block" color="error.main" />
						</Tooltip>
					)}
					{/* DEFAULT */}
					{props.model.phon_default && (
						<Tooltip title={t('DEFAULT_ITEM')} arrow>
							<Icon className="mr-2" icon="label-variant" />
						</Tooltip>
					)}
					{/* DESCRIPTION */}
					<Text className="font-600" variant="subtitle2">
						{props.model.phon_description || t('MODULE_PHONES_NAME_SINGULAR')}
					</Text>
				</Grid>
				<Grid size={12}>
					{/* PHONE NUMBER */}
					<ButtonLink href={`tel:${props.model.phon_title}`}>{props.model.phon_title}</ButtonLink>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
